// extracted by mini-css-extract-plugin
export var activeProgress = "styles-module__activeProgress___Mk3TQ";
export var progressContainer = "styles-module__progressContainer___GetZY";